// // components/SuccessMessage.jsx

// import React from 'react';
// import { CheckCircleIcon } from '@heroicons/react/24/outline';
// import { useNavigate } from 'react-router-dom';

// const SuccessMessage = ({ schoolName }) => {
//     const navigate = useNavigate();

//     const handleGoToDashboard = () => {
//         navigate('/'); // or '/dashboard' if that's your home page
//       };
//   return (
//     <div className="bg-slate-900 text-white p-8 rounded-lg shadow-lg text-center border border-emerald-600">
//       <CheckCircleIcon className="mx-auto h-16 w-16 text-emerald-500 mb-4" />
//       <h2 className="text-2xl font-bold mb-2">🎉 Registration Successful!</h2>
//       <p className="text-gray-300 mb-4">
//         Thank you for registering <span className="text-white font-medium">{schoolName}</span> with Isnartech ERP.
//       </p>
//       <p className="text-gray-400">
//         We've sent login credentials and further instructions to your registered email address.
//       </p>
//       <button
//         onClick={handleGoToDashboard}
//         className="mt-6 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md font-medium"
//       >
//         Go to Dashboard
//       </button>
//     </div>
//   );
// };

// export default SuccessMessage;


// components/SuccessMessage.jsx

import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const SuccessMessage = ({ schoolName, message, schoolId }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="bg-slate-900 text-white p-8 rounded-lg shadow-lg text-center border border-emerald-600">
      <CheckCircleIcon className="mx-auto h-16 w-16 text-emerald-500 mb-4" />
      <h2 className="text-2xl font-bold mb-2">🎉 Registration Received!</h2>
      <p className="text-gray-300 mb-2">
        Thank you for registering <span className="text-white font-medium">{schoolName}</span> with Eduvantra ERP.
      </p>
      {schoolId && (
        <p className="text-gray-400 mb-2">
          Your reference School ID is <span className="text-white font-mono">{schoolId}</span> — keep this for your records.
        </p>
      )}
      <p className="text-gray-400">
        {message ||
          "Your submission is now under review. You'll receive an email with your login credentials once it's approved."}
      </p>
      <button
        onClick={handleBackToHome}
        className="mt-6 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md font-medium"
      >
        Back to Home
      </button>
    </div>
  );
};

export default SuccessMessage;